import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "David Smith",
        title: "Master Carpenter",
        biography: "David Smith is a skilled master carpenter known for his exceptional craftsmanship and attention to detail. With years of experience in woodworking, he specializes in creating bespoke woodwork pieces that elevate spaces with their beauty and functionality. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum! Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!",
        contacts: {
            phone: "111-222-3344",
            email: "david.smith@example.com",
            website: "www.davidsmith.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Restoration Expert",
            "Custom Furniture Maker",
            "Woodcarving Specialist",
            "Master Carpenter",
            "Fine Woodworker"
        ],
        skills: [
            { id: 1, title: "Woodworking", progress: 95 },
            { id: 2, title: "Custom Furniture Making", progress: 90 },
            { id: 3, title: "Woodcarving", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Emma Johnson",
        title: "Woodwork Specialist",
        biography: "Emma Johnson is a dedicated woodwork specialist with a passion for crafting functional and artistic wooden creations. Her expertise spans custom cabinetry, detailed joinery, and finishing techniques that bring warmth and character to any project. She is committed to delivering quality craftsmanship with a creative touch.",
        contacts: {
            phone: "222-333-4455",
            email: "emma.johnson@example.com",
            website: "www.emmajohnsonwoodworks.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Custom Cabinet Maker",
            "Joinery Expert",
            "Finishing Technician",
            "Woodwork Specialist",
            "Interior Wood Design"
        ],
        skills: [
            { id: 1, title: "Joinery", progress: 92 },
            { id: 2, title: "Cabinet Making", progress: 90 },
            { id: 3, title: "Finishing Techniques", progress: 88 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Matthew Anderson",
        title: "Custom Furniture Maker",
        biography: "Matthew Anderson is a talented custom furniture maker renowned for his ability to blend functionality with artistic design. With a deep understanding of wood types and construction techniques, he creates bespoke furniture pieces that reflect both style and durability. His work ranges from elegant dining tables to intricate storage solutions, each crafted to meet unique client needs.",
        contacts: {
            phone: "333-444-5566",
            email: "matthew.anderson@example.com",
            website: "www.matthewandersoncrafts.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Bespoke Furniture Builder",
            "Wood Selection Expert",
            "Modern Design Specialist",
            "Custom Furniture Maker",
            "Functional Wood Artist"
        ],
        skills: [
            { id: 1, title: "Furniture Design", progress: 93 },
            { id: 2, title: "Wood Joinery", progress: 91 },
            { id: 3, title: "Surface Finishing", progress: 87 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Olivia Brown",
        title: "Master Woodcarver",
        biography: "Olivia Brown is a master woodcarver celebrated for her intricate detailing and creative flair. With a passion for transforming raw timber into ornate designs, Olivia brings stories to life through wood. Her carvings—ranging from decorative panels to heritage restorations—showcase precision, patience, and an unmatched artistic vision.",
        contacts: {
            phone: "444-555-6677",
            email: "olivia.brown@example.com",
            website: "www.oliviabrowncarvings.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Architectural Woodcarving",
            "Restoration Projects",
            "Sculptural Detailing",
            "Master Woodcarver",
            "Custom Decorative Work"
        ],
        skills: [
            { id: 1, title: "Woodcarving", progress: 98 },
            { id: 2, title: "Pattern Design", progress: 90 },
            { id: 3, title: "Restoration Work", progress: 88 }
        ]
    }

];

export default team;